import React from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';
import Scrollbar from 'src/components/scrollbar';
import { UserPermissionsDict } from 'src/_mock/permissions';
import AdmPermissionsRow from '../adm-permissions-row/adm-permissions-row';
import { UserPermissions } from 'src/types/users';
import { useMyDataStore } from 'src/store/me/me.store';

export interface AdmPermissionsProps {
  userPermissions: UserPermissions;
  onChangePermissions: (c: boolean, v: string, a: string) => void;
}

export default function AdmPermissions({
  userPermissions,
  onChangePermissions,
}: AdmPermissionsProps) {
  const canManageTrailStylePermission = useMyDataStore((state) =>
    Boolean(
      state.me?.roles?.includes('cn_admin') && state.me?.cnAdminInfo?.permissions?.trails?.style
    )
  );

  // const { } = useAdmPermissions();
  return (
    <Stack p={2}>
      <Typography variant="h4" sx={{ color: (theme) => theme.palette.grey[900] }}>
        Permissões
      </Typography>

      <Scrollbar>
        <Stack sx={{ minWidth: '400px' }}>
          <Grid container mt={2}>
            <Grid item xs={4} />
            <Grid item xs={2}>
              <Typography variant="body1" textAlign="center">
                Ler
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body1" textAlign="center">
                Criar
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body1" textAlign="center">
                Atualizar
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body1" textAlign="center">
                Deletar
              </Typography>
            </Grid>
          </Grid>
          {UserPermissionsDict.map((item: any, index: number) => (
            <Box key={`PermissionRow_${index}`} mt={2}>
              <AdmPermissionsRow
                title={item.title}
                isChildren={false}
                auth={item.auth}
                hasSelects={!item.children}
                onChangePermissions={onChangePermissions}
                userPermissions={userPermissions}
              />
              {item?.children?.map((children: any, idx: number) =>
                children.auth ? (
                  <React.Fragment key={`PermissionGroup_${children.title}_${idx}`}>
                    <AdmPermissionsRow
                      title={children.title}
                      hasSelects
                      isChildren
                      auth={children.auth}
                      onChangePermissions={onChangePermissions}
                      userPermissions={userPermissions}
                    />
                    {children.auth === 'clients' && (
                      <AdmPermissionsRow
                        title="Histórico de notas"
                        hasSelects
                        isChildren
                        indentLevel={2}
                        auth="clients"
                        actionColumns={['invoicesHistory', null, null, null]}
                        onChangePermissions={onChangePermissions}
                        userPermissions={userPermissions}
                      />
                    )}
                  </React.Fragment>
                ) : null
              )}
              {item.auth === 'trails' && canManageTrailStylePermission && (
                <AdmPermissionsRow
                  key="PermissionRow_trail_style"
                  title="Estilizar Trilha"
                  hasSelects
                  isChildren
                  auth="trails"
                  actionColumns={[null, null, 'style', null]}
                  onChangePermissions={onChangePermissions}
                  userPermissions={userPermissions}
                />
              )}
            </Box>
          ))}
        </Stack>
      </Scrollbar>
    </Stack>
  );
}
